export const tryParseJson = (value) => {
	try {
		return JSON.parse(value);
	} catch (e) {
		return undefined;
	}
};
